import { queryOptions, type UseQueryOptions } from '@tanstack/react-query';
import type {
  ListValorantAgentsData,
  ListValorantAgentsResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getValorantAgentsKey = () => ['valorant', 'agents'] as const;

const getValorantAgentsUrl: ListValorantAgentsData['url'] = 'valorant/agents';

export const getValorantAgentsOptions = <T = ListValorantAgentsResponse>(
  options?: Omit<
    UseQueryOptions<ListValorantAgentsResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions<ListValorantAgentsResponse, unknown, T>({
    queryKey: getValorantAgentsKey(),
    queryFn: () =>
      PrivateApi.get(getValorantAgentsUrl).json<ListValorantAgentsResponse>(),
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
